// src/AboutPage.js
import React, { useContext, useState } from 'react';
import { GlobalStateContext } from './GlobalStateContext';
import GraphSelector from '../components/AveragesGraphSelect';
import { Link } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import SarTimeArchivesChart from './SarTimeArchivesChart';


const SarTimeArchivePage = () => {

        const {
        feedlots,
        handleFeedlotSelect,
        selectedFeedlot
    } = useContext(GlobalStateContext);

    const [selectedDate, setSelectedDate] = useState('');
    const [selectedFromDate, setSelectedFromDate] = useState(null);
    const [selectedToDate, setSelectedToDate] = useState(null);
    const [flaker, setFlaker] = useState(1)

    const handleDateChange = (dates) => {
        console.log("Received dates:", dates);
    };
 


    const flaker1FieldOptions = [
        { value: 'motor1', label: 'Motor #1 Amps', system: "sartime" },
        { value: 'motor2', label: 'Motor #2 Amps', system: "sartime" },
        { value: 'temp1', label: 'Flaker #1 Lower Steam Chest Temp', system: "sartime" },
        { value: 'temp2', label: 'Flaker #1 Upper Steam Chest Temp', system: "sartime" },
        { value: 'retention1', label: 'Flaker #1 Retention Time', system: "sartime" },
        { value: 'rpm1', label: 'Peg Feeder #1 RPM', system: "sartime"   }
    ]

    const flaker2FieldOptions = [
        { value: 'motor3', label: 'Motor #3 Amps', system: "sartime" },
        { value: 'motor4', label: 'Motor #4 Amps', system: "sartime" },
        { value: 'temp3', label: 'Flaker #2 Lower Steam Chest Temp', system: "sartime" },
        { value: 'temp4', label: 'Flaker #2 Upper Steam Chest Temp', system: "sartime" },
        { value: 'retention2', label: 'Flaker #2 Retention Time', system: "sartime" },
        { value: 'rpm2', label: 'Peg Feder #2 RPM', system: "sartime" }
    ]


    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 bg-gray-900 h-max p-3">
            {/* Welcome Section */}
            <div className="col-span-2 md:col-span-2 lg:col-span-4 bg-gradient-to-r from-#2f4858 to-#33658a p-6 rounded-lg shadow-3xl text-white" style={{ backgroundImage: 'linear-gradient(10deg, #2f4858 0%, #33658a 50%, #86bbd8 100%)' }}>
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold mb-2 lg:mb-0">SarComputer Dashboard</h1>
                        <p className="text-lg">Explore detailed graphs and historical data for each component.</p>
                    </div>
                     <div className="mt-4 lg:mt-0 shadow-3xl rounded-lg">
                        <Link to="/about">
                            <button className="bg-[#33658a] text-#2f4858 px-4 py-2 rounded-md shadow-xl hover:bg-[#2f4858] transition">
                                Learn More
                            </button>
                        </Link>
                    </div>
                </div>
            </div>

           
                <div className="col-span-2 md:col-span-1 lg:col-span-1 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl z-10 flex flex-col items-center">        
                    <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Date Range:</h2>
                    
                    {/* From Date Picker */}
                    <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
                        <DatePicker
                        selected={selectedFromDate} 
                        onChange={date => setSelectedFromDate(date)}
                        selectsStart
                        startDate={selectedFromDate}
                        endDate={selectedToDate}
                        dateFormat="yyyy/MM/dd"
                        placeholderText="From: yyyy/mm/dd"
                        className="bg-transparent outline-none w-full"
                        />
                    </label>

                    {/* To Date Picker */}
                    <label className="relative inline-flex items-center p-2 rounded-md bg-slate-100 text-gray-700 shadow-3xl mb-4">
                        <DatePicker
                        selected={selectedToDate} 
                        onChange={date => setSelectedToDate(date)}
                        selectsEnd
                        startDate={selectedFromDate}
                        endDate={selectedToDate}
                        minDate={selectedFromDate} // Prevents selecting a "to" date earlier than "from"
                        dateFormat="yyyy/MM/dd"
                        placeholderText="To: yyyy/mm/dd"
                        className="bg-transparent outline-none w-full"
                        />
                    </label>
                    </div>
            
                  {/* Feedlot Selection */}
                  {feedlots.length > 0 && (
                    <div className="col-span-2 lg:col-span-2 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl">
                      <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Feedlot:</h2>
                      <select
                        className="w-full cursor-pointer p-2 rounded-md bg-slate-100 text-gray-700 border border-gray-300 shadow-md"
                        onChange={handleFeedlotSelect}
                        value={selectedFeedlot ? feedlots.findIndex(feedlot => (feedlot.SarCompID === selectedFeedlot.SarCompID && feedlot.TMRID === selectedFeedlot.TMRID)) : ''}
                      >
                        <option value="">-- Select a Feedlot --</option>
                        {feedlots.map((feedlot, index) => (
                          <option key={index} value={index}>
                            {feedlot.Name || `Feedlot ${index + 1}`}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                    <div className="col-span-2 md:col-span-1 lg:col-span-1 bg-slate-400 bg-opacity-80 backdrop-filter backdrop-blur-lg p-4 rounded-lg shadow-3xl z-10 flex flex-col items-center">        
                        <h2 className="text-xl font-semibold text-gray-100 mb-4">Select a Flaker:</h2>
                    
                    
                        <div>
                            <button 
                            id='1' className={`block bg-[#33658a] bg-gray-700 text-white text-lg m-4 px-8 py-2 rounded-md shadow-xl hover:bg-gray-900 transition ${flaker === 1 ? "bg-gray-900": ""}`}
                            onClick={() => setFlaker(1)}>
                            Flaker #1
                            </button>

                            <button 
                            id='2' className={`block bg-[#33658a] bg-gray-700 text-white text-lg m-4 px-8 py-2 rounded-md shadow-xl hover:bg-gray-900 transition ${flaker === 2 ? "bg-gray-900": ""}`}
                            onClick={() => setFlaker(2)}>
                            Flaker #2
                            </button>
                        </div>
                        
                    </div>

            {/* Weekly Average Data Selection */}
            <div className='col-span-2 lg:col-span-4 bg-slate-400  p-4 rounded-lg shadow-3xl'>
                <div className=''>
                    <SarTimeArchivesChart selectedFromDate={selectedFromDate} 
                    selectedToDate={selectedToDate}
                    onDateChange={handleDateChange}
                    combinedFieldOptions={flaker === 2 ? flaker2FieldOptions : flaker1FieldOptions}/>
                </div>
            </div>
        </div>
    );
}
export default SarTimeArchivePage;
